// brcmpgid param to download link
/**
 * brcmpgid download link decorator
 * @version 0.0.1
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.brcmpgid
 * @requires module:avast.url.serialize
 * @requires module:avast.url.unserialize
 * @requires module:jquery
 * @copyright Avast Software s.r.o &copy;2015
 */
 avm.define('avast.web.brcmpgid', function(config) {
	'use strict';

	var serialize = avm.require('avast.url.serialize'),
		unserialize = avm.require('avast.url.unserialize'),
		$ = avm.require('jquery'),
		qs = unserialize(),
		els,
		pidWhitelist = ['ASB-DIRECT'],
		pidCidSuffix = '-CID',
		re = /^[a-z0-9]+$/i;

	if (qs && qs.brcmpgid && re.test(qs.brcmpgid)) {

		if ('URLSearchParams' in window) {
			pidWhitelist.forEach(function(pid) {
				els = document.querySelectorAll('[data-download-name="' + pid + '"]').forEach(function(el) {
					var downloadURL,
						downloadQueryString;

					if (el.href) {
						downloadURL = new URL(el.href);
						downloadQueryString = new URLSearchParams(downloadURL.search);

						downloadQueryString.set('product', pid + pidCidSuffix);
						downloadQueryString.set('tag', qs.brcmpgid);

						downloadURL.search = downloadQueryString.toString();
						el.href = downloadURL.toString();
					}
				});
			});
		} else {
			// Internet Explorer fallback
			for (var i = 0; i < pidWhitelist.length; i++) {
				console.log('[data-download-name="' + pidWhitelist[i] + '"]');
				$('[data-download-name="' + pidWhitelist[i] + '"]').each(function() {
					var el = this,
						downloadQueryString;

					downloadQueryString = unserialize(el.search);
					downloadQueryString.product += pidCidSuffix;
					downloadQueryString.tag = qs.brcmpgid;

					el.search = serialize(downloadQueryString);
				});
			}
		}
	}

	return els;
});

avm.require('avast.web.brcmpgid')();
